var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordToReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-record-to-report"
  }, "Record-to-Report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-record-to-report"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 16,
    height: 18,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7h10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10h10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17h2v1.5H8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5h2V18.5h-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.5h2V18.5h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordToReport);
export default __webpack_public_path__ + "static/media/record-to-report.c32c62e8bf62108bc8b607fa8af2b58f.svg";
export { ForwardRef as ReactComponent };